'use strict';

angular.module('atex.dam').controller('DamButtonSwitchController', [ '$scope', function($scope) {
  $scope.currentValue = undefined;

  if ($scope.selectedValue !== undefined) {
    $scope.currentItem = _.find($scope.array, function(item) {
      return item.value !== $scope.selectedValue;
    });
  }

  $scope.switchItem = function() {
    if ($scope.disabled) {
      return;
    }
    var oldIndex = $scope.array.indexOf($scope.currentItem);
    if (oldIndex === ($scope.array.length - 1)) {
      $scope.currentItem = $scope.array[0];
    } else {
      $scope.currentItem = $scope.array[oldIndex + 1];
    }
    $scope.selectCallBack({
      value : $scope.currentItem.value
    });
  };
} ]);

angular.module('atex.dam').directive('damButtonSwitch', function() {
  return {
    restrict : 'E',

    templateUrl : 'js/dam/widgets/dam-button-switch/dam-button-switch.html',

    replace : true,

    scope : {
      label : '@',
      array : '=',
      selectCallBack : '&',
      selectedValue : '=',
      disabled : '='
    },

    controller : 'DamButtonSwitchController',

    link : function(scope, element, attrs) {
      scope.$watch(function() {
        return scope.selectedValue;
      }, function(newValue, oldValue) {
        scope.currentItem = _.find(scope.array, function(item) {
          return item.value === scope.selectedValue;
        });
      });
    }
  };
});
